import t, { forwardRef as l } from "react";
import { Button as r } from "@mui/material";
import { L as u } from "./chunk.BPo6egul.js";
import { g as m } from "./chunk.BurCwd5X.js";
import { I as s } from "./chunk.zlc_6vey.js";
const M = l(
  ({ type: e = "base", ...o }, n) => {
    const a = e === "base" ? "text" : e, i = o.to ? {
      component: u,
      to: o.to
    } : {}, c = {
      variant: o.iconVariant,
      icon: o.icon,
      disabled: o.disabled
    };
    return /* @__PURE__ */ t.createElement(
      r,
      {
        id: o.id,
        disabled: o.disabled,
        onClick: o.onClick,
        variant: a,
        "aria-label": o.ariaLabel,
        ...i,
        ref: n,
        onBlur: o.onBlur,
        onFocus: o.onFocus,
        onMouseOver: o.onMouseOver,
        onMouseLeave: o.onMouseLeave,
        ...m(n)
      },
      /* @__PURE__ */ t.createElement(s, { ...c })
    );
  }
);
export {
  M as I
};
